import { render, staticRenderFns } from "./CallContactSetup.vue?vue&type=template&id=6962905d&scoped=true"
import script from "./CallContactSetup.vue?vue&type=script&lang=ts"
export * from "./CallContactSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6962905d",
  null
  
)

export default component.exports